function getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData) {
  if (!ajaxPage) ajaxPage = 0;
  if (!allAjaxData) allAjaxData = [];

  // We batch products so the wholesale URL stays under a safe length. 11 per call
  // keeps each `?view=boost-wholesale` request small (20 can produce URLs long
  // enough to fail on large collections). If more products exist, we make multiple calls.
  var productsPerCall = numberProductPerAjaxCall || 11;
  if (productsPerCall > 11){
    productsPerCall = 11;
  }
  var fromIndex = productsPerCall * ajaxPage;
  var toIndex = Math.min(data.length, productsPerCall * (ajaxPage + 1));
  var handles = [];
  for (var i = fromIndex; i < toIndex; i++) {
    handles.push(data[i].handle);
  }
  var handleString = handles.join("+");
	
	var url = Utils.buildProductItemUrl({handle: 'test' }, true);
  url = url.split('/products/')[0]
  
  if (!url.includes('collection')) {
    url += '/collections/all'
  } 
  
  var itemDataUrl = url + "/" + handleString + "?view=" + templateName;

   // Start fix BO - 63909322
  if(!Utils.isCollectionPage()) {
    itemDataUrl = itemDataUrl.replace("/collections//", "/collections/all/").replace("/account", "");
  }
  // End fix BO - 63909322

  jQ.ajax({
    type: "GET",
    url: itemDataUrl,
    success: function(ajaxData) {
      // the same call as buildExtrasProductListByAjax, with one extra params: ajaxData (the new data we just got from ajax call)
      onGetExtrasProductDataByAjaxSuccess(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, ajaxData, allAjaxData);
    },
    // If the wholesale ajax fails (e.g. URL too long, 404, timeout), never leave the
    // product list empty: fall back to the original prices so rendering always proceeds.
    error: function(jqXHR, textStatus, errorThrown) {
      console.error('[Wholesale] Could not load wholesale prices from ' + templateName + ', falling back to default prices. Status:', textStatus, '| URL length:', itemDataUrl.length, '| URL:', itemDataUrl);
      if (typeof callback == 'function') {
        callback([]);
      }
    }
  });
}

function onGetExtrasProductDataByAjaxSuccess(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, ajaxData, allAjaxData) {
  // Try to parse the json we get from collection endpoint
  try {
    if(/<\!--.*?-->/.test(ajaxData)){
      ajaxData = ajaxData.replace(/<\!--.*?-->/g, '');
    }
    // Add the new data to the "all data" list
    allAjaxData = allAjaxData.concat(JSON.parse(ajaxData).products);
  } catch (error) {
    console.error('Could not parse json from ' + templateName + ": " + error.message);
  }

  // We batch 11 products per ajax call (see getExtrasProductDataByAjax); if more
  // remain, keep fetching the next chunk.
  var productsPerCall = numberProductPerAjaxCall || 11;
  if (productsPerCall > 11){
    productsPerCall = 11;
  }
  var fromIndex = productsPerCall * ajaxPage;
  if (fromIndex < data.length - 1) {
    ajaxPage++;
    getExtrasProductDataByAjax(data, templateName, callback, numberProductPerAjaxCall, ajaxPage, allAjaxData);
  } else {
    // After getting all products from all pages, call the callback function
    if (typeof callback == 'function') {
      callback(allAjaxData);
    }
  }
}

var currency = boostPFSConfig.general.current_currency.toLowerCase();

function getNewPrices(apiData, productsData) {
  const result = {...apiData, products: [...apiData.products]};
  
  productsData.forEach(function(product) {
    var idx = result.products.findIndex(function(apiProduct) { return apiProduct.id === product.id });
    if (idx >= 0) {
      result.products[idx].compare_at_price_min = product.compare_at_price_min / 100
      result.products[idx].price_min = product.price_min / 100
      result.products[idx].price_max = product.price_max / 100

      result.products[idx]['compare_at_price_min_' + currency] = product.compare_at_price_min / 100
      result.products[idx]['price_min_' + currency] = product.price_min / 100
      result.products[idx]['price_max_' + currency] = product.price_max / 100
      
      for (var variant of product.variants) {
        var vidx = result.products[idx].variants.findIndex(v => v.id === variant.id);
        if (vidx === -1) continue;
        
        result.products[idx].variants[vidx].price = variant.price / 100;
        result.products[idx].variants[vidx].compare_at_price = variant.compare_at_price / 100;
      }
    }          
  });

  return result;
}

if (typeof FilterApi !== 'undefined') {
  FilterApi.afterCallAsync = function(result, callbackFilterApi) {      
    var currency = boostPFSConfig.general.current_currency.toLowerCase();
    if (result.products.length === 0 || !boostPFSConfig.customer.isLogged) { /* currency check */
      callbackFilterApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-wholesale", function(productsData) {
      callbackFilterApi(getNewPrices(result, productsData));
    });
  }
}

if (typeof InstantSearchApi !== 'undefined') {
  InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
    var currency = boostPFSConfig.general.current_currency.toLowerCase();

    if (result.products.length === 0 || !boostPFSConfig.customer.isLogged) { /* currency check */
      callbackInstantSearchApi(result);
      return;
    }

    getExtrasProductDataByAjax(result.products, "boost-wholesale", function(productsData) {
      callbackInstantSearchApi(getNewPrices(result, productsData));
    });
  }
}